import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[qvsClickKeydownEnterSpace]',
  standalone: true
})
export class ClickKeydownEnterSpaceDirective {
  @Output() clickAndKeydown = new EventEmitter<Event>();

  // in order to improve accessibility, click events are handled the same as keyDown
  // events for the enter and spacebar keys to work more smoothly with assistive technologies like screen readers
  @HostListener('click', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.Space', ['$event'])
  onClickOrKeydown(event: Event) {
    this.clickAndKeydown.emit(event);
  }
}
